export const APP_ROUTES = {
  ROOT: '/',
  ABOUT: '/about',
  CAREERS: '/careers',
  BONDS: '/investors',
  CONTACTS: '/contacts',
  DIRECT_LOANS: '/directloans',
  CAREERS_LIST: '/careers/list',
  CAREERS_DETAIL: '/careers/detail/:shortCode',
  INVALID: '*',
  NOT_FOUND: '/404',
  DISCLAIMER: '/disclaimer',
  COOKIE_POLICY: '/cookie-policy',
  NEWS: '/news',
  ARTICLE: '/article/:id',
  PRODUCTS: '/products'
}
